export default __webpack_public_path__ + "static/media/thankyou_bg.54ec3633.svg";